
































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Sidebar extends Vue {
    setNav () {
        this.$store.commit('setSideNavFalse')
    }
}
